<template>
  <CartButton
    :items="cartStore.items?.length"
    :count="cartStore.updated && cartStore.getTotalTicketsInCart"
    @click="cartStore.openCart()" />
</template>

<script setup>
import CartButton from "@/components/cart/CartButton.vue";
import { useCartStore } from "@/store/cart.ts";

const cartStore = useCartStore();
</script>
